export enum DatesRangeType {
  Next90Days = 'Next90Days',
  Next60Days = 'Next60Days',
  Next30Days = 'Next30Days',
  ThisAndNext2Months = 'ThisAndNext2Months',
  ThisAndNextMonth = 'ThisAndNextMonth',
  ThisMonth = 'ThisMonth',
}
